export const getInitialTemplateValues = (template) => ({
  ...template,
  isExpanded: true,
  isSelected: true,
});
